import {
  Description,
  TextWrapper,
  SectionContainer,
  TitleText,
  SubTitleText,
} from './styles';
import heroSectionDefaultBackgroundImage from '@assets/images/hero-section-default.png';
import Button from '@components/Button';
import UnderLine from '@components/Underline';
import { getEventDetails } from '@store/slices/eventSlice';
import { useMobileWidth } from '@utils/hooks';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  description: string;
  descriptionMaxWidth?: string;
  backgroundImage?: string;
  backgroundImageZoom?: string;

  darkOverlay?: boolean;
  buttonText?: string;
  buttonURL?: string;
  buttonOnClick?: () => void;
  textColor?: string;
  gap?: string;
  height?: string;
}

const HeroSection = ({
  title,
  subtitle,
  description,
  descriptionMaxWidth,
  backgroundImage = heroSectionDefaultBackgroundImage,
  backgroundImageZoom = '',
  darkOverlay = false,
  buttonText,
  buttonURL,
  buttonOnClick,
  textColor,
  gap,
  height,
}: HeroSectionProps) => {
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const { design } = sluggedEvent || { design: {} };
  const theme = useTheme();
  const isMobile = useMobileWidth();

  return (
    <SectionContainer
      backgroundImage={backgroundImage}
      backgroundImageZoom={backgroundImageZoom}
      darkOverlay={darkOverlay}
      height={height}
    >
      <TextWrapper $gap={gap || (isMobile ? '2.5rem' : '3rem')}>
        <TitleText color={textColor || theme.color.white}>{title}</TitleText>
        {subtitle && (
          <SubTitleText color={textColor || theme.color.white}>
            {subtitle}
          </SubTitleText>
        )}

        <UnderLine width="163px" color={design.themeColor} />

        <Description
          color={textColor || theme.color.white}
          descriptionMaxWidth={descriptionMaxWidth}
        >
          {description.split('\n').map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              {idx < description.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </Description>

        {buttonText && (
          <Button
            title={buttonText}
            backgroundColor={sluggedEvent?.design?.themeColor}
            hoverBackgroundColor={theme.color.mobilityGrey}
            textColor={theme.color.white}
            fontSize="2rem"
            lineHeight="150%"
            borderRadius="1.2rem"
            padding={isMobile ? '1.1rem 2.5rem' : '1.1rem 5rem'}
            width="fit-content"
            onClick={() => {
              if (buttonOnClick) {
                buttonOnClick();
              } else if (buttonURL) {
                window.open(`${buttonURL}`, '_blank', 'noopener,noreferrer');
              }
            }}
          />
        )}
      </TextWrapper>
    </SectionContainer>
  );
};

export default HeroSection;
